import { render, staticRenderFns } from "./MissingPurchaseInvoices.vue?vue&type=template&id=206477a4&"
import script from "./MissingPurchaseInvoices.vue?vue&type=script&lang=js&"
export * from "./MissingPurchaseInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports